import React, { useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import './public-user.style.css';
import { PublicUsersProfileContext } from '../../../services/public-users-profile/public-users-profile.context';
import { Link } from 'react-router-dom';

export const About = () => {
  const { userInfo } = useContext(PublicUsersProfileContext);

  return (
    <Box boxShadow={1} className='public-user-container'>
      <Box p={3}>
        <Box mb={2}>
          <Typography className='public-user-header' variant='h2'>
            About
          </Typography>
        </Box>
        <Typography className='public-user-about-body'>
          {userInfo && userInfo.about_me && userInfo.about_me}
        </Typography>
      </Box>
    </Box>
  );
};
